import { WOPI_FILE_PAGE } from "src/urls.ts";

export const openWopiFilePage = (action: WopiAction, fileUuid: string) => {
	const url = `/${WOPI_FILE_PAGE}/${action}/${fileUuid}`;
	window.open(url, "_blank");
};

export type WopiAction =
	"view" | "embed_view" | "edit" | "edit_new";